import { ThunkType } from "../../../../core/store/reducers";
import { setData } from "../annualTradeDataSlice";
import getAnnualClientData from "../api/getAnnualClientData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.annualTrade;

  const pagedTrades = await dispatch(getAnnualClientData(user, filter));

  dispatch(setData(pagedTrades || []));
};
